
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.833 14.667a.167.167 0 01-.166-.167v-3.011c0-.092.074-.167.166-.167H14.5c.092 0 .167.075.167.167v2.844c0 .184-.15.334-.334.334h-5.5zm-7.5-5.845c0-.092.075-.167.167-.167h5.667c.092 0 .166.075.166.167V14.5a.167.167 0 01-.166.167h-5.5a.333.333 0 01-.334-.334V8.822zm5.834-7.489c.092 0 .166.075.166.167v5.655a.167.167 0 01-.166.167H1.5a.167.167 0 01-.167-.167V1.667c0-.184.15-.334.334-.334h5.5zm1.5 4.822c0-.092.074-.166.166-.166H14.5c.092 0 .167.074.167.166v3.667a.167.167 0 01-.167.167H8.833a.167.167 0 01-.166-.167V6.155zm6-1.666a.167.167 0 01-.167.166H8.833a.167.167 0 01-.166-.166V1.5c0-.092.074-.167.166-.167h5.5c.184 0 .334.15.334.334v2.822zm0-4.489H1.333C.597 0 0 .597 0 1.333v13.334C0 15.403.597 16 1.333 16h13.334c.736 0 1.333-.597 1.333-1.333V1.333C16 .597 15.403 0 14.667 0z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    